(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileSlackFileInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "mimeIcons", "fileDao", "sideMenuManager", "modulesDao", "metaInfoConverter", "$filter", "rolesManager", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, mimeIcons, fileDao, sideMenuManager, modulesDao, metaInfoConverter, $filter, rolesManager) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/slack_file/slack-file-info').template('slack-file-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                $scope.widgetApi = {};
                $scope.model = {};
                $scope.input = {};
                $scope.loadData = function () {
                    return $q.allSettled([
                        fileDao.entityInfo('slack_file', id),
                        mimeIcons()
                    ]).then(function (responses) {
                        var input = {};
                        input.originData = responses[0].value && responses[0].value.data || {};
                        // info logic
                        var icons = responses[1].value;
                        var msgIcon = icons(input.originData.mimetype || 'text/plain');
                        var fileName = input.originData.file_name;
                        $scope.model.info = {};
                        $scope.model.info.lines = [
                            {
                                img: msgIcon,
                                class: 'profile-image'
                            },
                            {
                                text: fileName,
                                class: 'file-name'
                            },
                            {
                                text: $filter('bytes')(input.originData.size) || '',
                                class: 'file-size'
                            }
                        ];
                        var queries = [modulesDao.entityInfo('slack', 'slack_file')];
                        var userInfo, channelInfo;
                        if (input.originData && input.originData.actor_id) {
                            queries.push(fileDao.entityInfo('slack_user', input.originData.actor_id));
                            userInfo = true;
                        }
                        if (input.originData && input.originData.channel_id) {
                            queries.push(fileDao.entityInfo('slack_channel', input.originData.channel_id));
                            channelInfo = true;
                        }
                        $q.allSettled(queries).then(function (respes) {
                            input.entityInfo = respes[0].value && respes[0].value.data || {};
                            input.resolvers = {
                                actor_id: {},
                                channel_id: {}
                            };
                            if (userInfo) {
                                input.resolvers.actor_id = respes[1].value && respes[1].value.data || {};
                            }
                            if (channelInfo) {
                                input.resolvers.channel_id = respes[respes.length - 1].value && respes[respes.length - 1].value.data || {};
                            }
                            // meta-info logic
                            var metaInfo = {
                                key: {},
                                value: {},
                                pair: { class: 'file-meta-data' },
                                args: {
                                    beautifyKey: true,
                                    whiteList: [
                                        'create_time',
                                        'mimetype_human',
                                        {
                                            key: 'channel_id',
                                            type: 'resolver',
                                            resolverEntity: 'slack_channel',
                                            resolverKey: 'name'
                                        },
                                        {
                                            key: 'actor_id',
                                            type: 'resolver',
                                            resolverEntity: 'slack_user',
                                            resolverKey: 'display_name'
                                        },
                                        'mode',
                                        'is_external',
                                        'is_public',
                                        'is_public_url_shared',
                                        {
                                            key: 'is_display_as_bot',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_deleted',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_tombstoned',
                                            hiddenPairAny: { value: false }
                                        }
                                    ]
                                }
                            };
                            if (sideMenuManager.currentUser().view_private_data) {
                                metaInfo.args.whiteList.push({
                                    key: 'is_display_as_bot',
                                    hiddenPairAny: { value: false }
                                }, 'url_private', 'url_private_download', 'permalink');
                            }
                            metaInfo.data = metaInfoConverter(input, metaInfo.args);
                            $scope.model.metaInfo = metaInfo;
                            // actions
                            $scope.model.actionsWidget = {
                                type: 'actions',
                                logic: {
                                    name: 'remediationActionsLogic',
                                    updateTick: 30000,
                                    entityType: 'slack_file',
                                    entityDataSlave: true
                                },
                                'class': 'file-info-actions-widget wide-250-buttons',
                                wrapper: { type: 'none' },
                                actions: rolesManager.isActionAllowed([
                                    'admin',
                                    'user',
                                    'operations'
                                ]) ? [
                                    {
                                        autoId: 'profile_manual_action_btn_slack_file_tombstone',
                                        actionType: 'slack_file_tombstone',
                                        hiddenEntityAny: {
                                            is_deleted: true,
                                            is_tombstoned: true
                                        }
                                    },
                                    {
                                        autoId: 'profile_manual_action_btn_slack_file_tombstone_restore',
                                        actionType: 'slack_file_tombstone_restore',
                                        hiddenEntityAny: { is_tombstoned: false }
                                    }
                                ] : [],
                                entityData: input.originData
                            };
                        });
                        $scope.input = input;
                    }, function (err) {
                        console.log('Error in slack file info:', err);
                    });
                };
                $scope.updateActionButtonsState = function (action) {
                    var actions = [
                        'slack_file_tombstone_restore',
                        'slack_file_tombstone'
                    ];
                    if (actions.includes(action.name)) {
                        $scope.input.originData.is_tombstoned = !$scope.input.originData.is_tombstoned;
                        $scope.model.metaInfo.data = metaInfoConverter($scope.input, $scope.model.metaInfo.args);
                    }
                };
                widgetPolling.on('remediationActionPerformed', function (action) {
                    $scrop.updateActionButtonsState(action);
                });
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
            }
        };
    }]);
}());